/* unplugin-vue-components disabled */import { render } from "./collapse-menu.vue?vue&type=template&id=6bb10802&scoped=true"
import script from "./collapse-menu.vue?vue&type=script&lang=js"
export * from "./collapse-menu.vue?vue&type=script&lang=js"

import "./collapse-menu.vue?vue&type=style&index=0&id=6bb10802&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6bb10802"],['__file',"src/controls/collapse-menu.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6bb10802"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6bb10802', __exports__)) {
    api.reload('6bb10802', __exports__)
  }
  
  module.hot.accept("./collapse-menu.vue?vue&type=template&id=6bb10802&scoped=true", () => {
    api.rerender('6bb10802', render)
  })

}


export default __exports__